"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var campaign_1 = require("../campaign");
var DebugMenu = function (_super) {
  __extends(DebugMenu, _super);
  function DebugMenu() {
    var _this = _super.call(this) || this;
    _this.showCampaign = function (id, value) {
      var isInDatalayer = typeof value !== "undefined";
      var campaignObj = {
        id: id,
        isInDatalayer: isInDatalayer,
        value: value
      };
      _this.setState(function (prevState) {
        return {
          campaigns: __assign({}, prevState.campaigns, (_a = {}, _a[id] = campaignObj, _a))
        };
        var _a;
      });
    };
    _this.state = {
      campaigns: []
    };
    return _this;
  }
  DebugMenu.prototype.componentDidMount = function () {
    campaign_1.subscribeToCampaigns(this.showCampaign);
  };
  DebugMenu.prototype.render = function () {
    var rows = [];
    var _loop_1 = function _loop_1(key) {
      rows.push(React.createElement("div", null, React.createElement("b", null, key), " -", React.createElement("select", {
        onChange: function onChange(_a) {
          var value = _a.target.value;
          campaign_1.updateCampaign(key, parseInt(value, 10));
        },
        value: this_1.state.campaigns[key].value
      }, React.createElement("option", {
        value: 0
      }, "Control"), React.createElement("option", {
        value: 1
      }, "B"), React.createElement("option", {
        value: 2
      }, "C"), React.createElement("option", {
        value: 4
      }, "D"), React.createElement("option", {
        value: 5
      }, "E")), !this_1.state.campaigns[key].isInDatalayer && React.createElement("p", {
        style: {
          fontSize: "10px"
        }
      }, React.createElement("i", null, "Not found in datalayer"))));
    };
    var this_1 = this;
    for (var _i = 0, _a = Object.keys(this.state.campaigns); _i < _a.length; _i++) {
      var key = _a[_i];
      _loop_1(key);
    }
    return React.createElement("div", {
      style: {
        position: "fixed",
        bottom: 0,
        right: 15,
        padding: "0 15px 15px",
        width: "200px",
        backgroundColor: "#efefef"
      }
    }, React.createElement("span", {
      style: {
        display: "inline-block",
        marginBottom: "10px"
      }
    }, React.createElement("b", null, "Campaign ID"), " - Variant ID"), rows);
  };
  return DebugMenu;
}(React.Component);
exports["default"] = DebugMenu;
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/components/DebugMenu.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/components/DebugMenu.js");
  }
}();